import { render, staticRenderFns } from "./BankChooser.vue?vue&type=template&id=58bc63ba&scoped=true&"
import script from "./BankChooser.vue?vue&type=script&lang=js&"
export * from "./BankChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bc63ba",
  null
  
)

export default component.exports